import React from 'react';

const HeroSection = () => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content-wrapper">
          <div className="hero-text">
            <h1>Master Poker GTO Strategy</h1>
            <p className="subtitle">
              Access pre-solved poker ranges anywhere and improve your game with GTO Preflop
            </p>
            {/* <div className="app-buttons">
              <a href="https://apps.apple.com/us/app/gto-preflop/id1629141961" className="app-store-btn">
                <img src="/img/app-store-badge.svg" alt="Download on the App Store" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.gtopreflopfree.gtopreflopfree" className="play-store-btn">
                <img src="/img/play-store-badge.svg" alt="Get it on Google Play" />
              </a>
            </div> */}
          </div>
          <div className="hero-image-container">
            <img 
              src="/img/mockups/mockup with hand.png" 
              alt="GTO Preflop App Mockup" 
              className="hero-mockup-image" 
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 